// extracted by mini-css-extract-plugin
export default {"manageGroups":"_CKavxihxj06VzN0gQ9T"};